<label>Applicant Type </label>
<select name="CB" [(ngModel)]="applicantType">
	<option value="primary">Primary</option>
	<option value="co_applicant">Co-Applicant</option>
</select>
<br />
<button class="buttonBlue">Create</button>
<button class="buttonBlue">Edit</button>
<button class="buttonRed">Delete</button>
